import { useState } from 'react'
import { useDispatch } from 'react-redux'
import { useParams } from 'react-router-dom'
import { Box } from '@mui/material'

import { invitePartnerToKazoo } from '../../features/kazooEventSlice'
import InputCustom from '../atoms/input/InputCustom'
import ButtonCustom from '../atoms/button/ButtonCustom'

import styles from './invite.module.scss'
import { toastHelper } from '../../util/toastHelper'
import { EMAIL_RE } from '../../util/constants'

export const InvitePartnerForm = () => {
	const { kazooId } = useParams()
	const dispatch = useDispatch()
	const [email, setEmail] = useState('')

	const handleChange = (e) => {
		setEmail(e.target.value)
	}

	const handleSubmit = (e) => {
		e.preventDefault()
        if (!EMAIL_RE.test(email)) return toastHelper('Invalid email', 'error')
		dispatch(invitePartnerToKazoo({ kazooId, email: email.toLowerCase() }))
	}
	return (
		<form onSubmit={handleSubmit} className={styles.cardContainer}>
			<h2 className={styles.subTitle}>Please enter their email to send an invite</h2>
			<InputCustom
				data-cy="invite-email"
				placeholder="Email"
				name="email"
				type="email"
				value={email}
				autoFocus={true}
				onChange={handleChange}
				required={true}
			/>
			<ButtonCustom
				data-cy="invite-submit-button"
				type="submit"
				className={styles.inviteBtn}
			>
				Send Invite
			</ButtonCustom>
		</form>
	)
}
